const MIN_PASSWORD_LENGTH = 7;
const MAX_PASSWORD_LENGTH = 64;

type PasswordCriteria = {
    lengthCriteria: boolean;
    lowerAndUpperCaseCriteria: boolean;
    numberOrSpecialCharCriteria: boolean;
    passwordValid: boolean;
};

const usePasswordCriteria = (password: string): PasswordCriteria => {
    const lengthCriteria = password.length >= MIN_PASSWORD_LENGTH && password.length <= MAX_PASSWORD_LENGTH;
    const lowerAndUpperCaseCriteria = /(?=.*[a-z])(?=.*[A-Z])/.test(password);
    const numberCriteria = /(?=.*\d)/.test(password);
    const specialCharacterCriteria = /[*@!#%&()^~{}]+/.test(password);

    return {
        lengthCriteria,
        lowerAndUpperCaseCriteria,
        numberOrSpecialCharCriteria: numberCriteria || specialCharacterCriteria,
        passwordValid: lengthCriteria && lowerAndUpperCaseCriteria && (numberCriteria || specialCharacterCriteria),
    };
};

export default usePasswordCriteria;
